import { render, staticRenderFns } from "./ContactanosView.vue?vue&type=template&id=54d23190&scoped=true"
import script from "./ContactanosView.vue?vue&type=script&lang=js"
export * from "./ContactanosView.vue?vue&type=script&lang=js"
import style0 from "./ContactanosView.vue?vue&type=style&index=0&id=54d23190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d23190",
  null
  
)

export default component.exports